import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Select, { SELECT_MENU_ABOVE_MODAL_PROPS } from "../../../Form/Select";
import {
  COMPETITOR_FILTER_ADD_VALUE,
  COMPETITOR_FILTER_BAR_SX,
  COMPETITOR_FILTER_SELECT_SX,
  COMPETITOR_FILTER_SELECT_WRAPPER_SX,
  COMPETITOR_PLATFORM_FILTER_SELECT_WRAPPER_SX,
  COMPETITORS_COMPETITOR_FILTER_FIELD,
  COMPETITORS_PLATFORM_FILTER_FIELD,
} from "../constants";

const NOOP = () => {};
const VALIDATION_ALLOW = async () => true;

const AddCompetitorOptionLabel = ({ label }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <AddIcon
      sx={{
        ml: -0.5,
        fontSize: 20,
        color: "background.paperContrastText",
      }}
    />
    <Typography variant="body2" component="span">
      {label}
    </Typography>
  </Box>
);

const renderPlatformFilterValue = ({ value, options }) => {
  const selectedOption = options.find((option) => option.value === value);
  if (!selectedOption) return "";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {selectedOption.iconSrc ? (
        <Box
          component="img"
          src={selectedOption.iconSrc}
          alt=""
          sx={{
            width: 16,
            height: 16,
            objectFit: "contain",
            display: "block",
            flexShrink: 0,
          }}
        />
      ) : null}
      {selectedOption.label}
    </Box>
  );
};

const CompetitorsFilterBar = ({
  control,
  platformFilterOptions = [],
  competitorFilterOptions = [],
  onPlatformFilterChange = NOOP,
  onCompetitorFilterChange = NOOP,
  onCompetitorFilterValidationChange = VALIDATION_ALLOW,
  addOptionLabel,
}) => {
  const competitorOptionsWithAdd = [
    {
      value: COMPETITOR_FILTER_ADD_VALUE,
      label: <AddCompetitorOptionLabel label={addOptionLabel} />,
    },
    ...competitorFilterOptions,
  ];

  return (
    <Box sx={COMPETITOR_FILTER_BAR_SX}>
      <Box sx={COMPETITOR_PLATFORM_FILTER_SELECT_WRAPPER_SX}>
        <Select
          control={control}
          name={COMPETITORS_PLATFORM_FILTER_FIELD}
          options={platformFilterOptions}
          rules={{ required: false }}
          doTranslate={false}
          MenuProps={SELECT_MENU_ABOVE_MODAL_PROPS}
          variant="filled"
          sx={COMPETITOR_FILTER_SELECT_SX}
          actionsChange={onPlatformFilterChange}
          renderValue={(value) =>
            renderPlatformFilterValue({
              value,
              options: platformFilterOptions,
            })
          }
        />
      </Box>
      <Box sx={COMPETITOR_FILTER_SELECT_WRAPPER_SX}>
        <Select
          control={control}
          name={COMPETITORS_COMPETITOR_FILTER_FIELD}
          options={competitorOptionsWithAdd}
          rules={{ required: false }}
          doTranslate={false}
          displayEmpty
          MenuProps={SELECT_MENU_ABOVE_MODAL_PROPS}
          variant="filled"
          sx={COMPETITOR_FILTER_SELECT_SX}
          validationChange={onCompetitorFilterValidationChange}
          actionsChange={onCompetitorFilterChange}
        />
      </Box>
    </Box>
  );
};

export default CompetitorsFilterBar;
